<template>
  <div class="index">
    <div class="gradient"></div>
    <div class="content">
      <h1 class="heading">MontyPay Payment Gateway</h1>
      <form @submit.prevent="submit" class="form">
        <label class="label">
          <span class="lbl">API Key</span>
          <input
            v-model="apiKey"
            type="text"
            placeholder="API Key"
            oninput=""
            class="input"
          />
        </label>
        <label class="label">
          <span className="lbl">Merchant Password</span>
          <input
            v-model="merchantPassword"
            type="text"
            placeholder="Configuration Password"
            class="input"
          />
        </label>
        <label class="label">
          <span className="lbl">Merchant Key</span>
          <input
            v-model="merchantKey"
            type="text"
            placeholder="Merchant Key"
            class="input"
          />
        </label>
        <button class="button" type="submit">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WalletConfigurationPage",
  data() {
    return {
      errorState: false,
      errorMsg: "",
      loading: true,
      apiKey: "",
      merchantPassword: "",
      shop: "",
      domain: "",
      config: {},
      session: {},
      merchantKey: "",
    };
  },
  methods: {
    async getData(shop, domain) {
      const config = await axios
        .get(`/wallet/configuration/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Config:", resp.data);
          return resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Config:", err.response.data);
        });
      const session = await axios
        .get(`/wallet/session/get?shop=${shop || domain}`)
        .then((resp) => {
          // console.log("Session:", resp.data);
          return resp.data;
        })
        .catch((err) => {
          console.log("Error in getting Session:", err.response.data);
        });

      // const session = await window.session.getSessionByShop(shop || domain);
      this.config = config;
      this.session = session;
      return { config: config, session: session };
    },
    async submit() {
      await axios
        .post("/wallet/configuration/update", {
          shop: this.$route.query.shop,
          apiKey: this.apiKey,
          merchantPassword: this.merchantPassword,
          merchantKey: this.merchantKey,
        })
        .then((resp) => {
          console.log("Resp:", resp.data);

          window.location.href = resp.data.redirect_url;
        })
        .catch((err) => {
          console.error(err);
          alert("Submition failed");
        });
    },
  },
  async mounted() {
    const shop = this.$route.query.shop;
    const domain = this.$route.query.domain;
    if (shop) {
      this.shop = shop;
      this.domain = domain;
      await this.getData(shop, domain);
      this.apiKey = this.config.apiKey;
      this.merchantPassword = this.config.merchantPassword;
      this.merchantKey = this.config.merchantKey;
    }
  },
  beforeUnmount() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

#config_page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      max-height: 70px;
      aspect-ratio: auto;
    }
  }
}

#lll {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .loader {
    margin-top: 2rem;
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #155eef;
    animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  }
}
@keyframes l20-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
  }
  12.5% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 0%,
      100% 0%,
      100% 0%
    );
  }
  25% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      100% 100%,
      100% 100%
    );
  }
  50% {
    clip-path: polygon(
      50% 50%,
      0 0,
      50% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  62.5% {
    clip-path: polygon(
      50% 50%,
      100% 0,
      100% 0%,
      100% 0%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  75% {
    clip-path: polygon(
      50% 50%,
      100% 100%,
      100% 100%,
      100% 100%,
      100% 100%,
      50% 100%,
      0% 100%
    );
  }
  100% {
    clip-path: polygon(
      50% 50%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      50% 100%,
      0% 100%
    );
  }
}
@keyframes l20-2 {
  0% {
    transform: scaleY(1) rotate(0deg);
  }
  49.99% {
    transform: scaleY(1) rotate(135deg);
  }
  50% {
    transform: scaleY(-1) rotate(0deg);
  }
  100% {
    transform: scaleY(-1) rotate(-135deg);
  }
}

.index {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #0f0c22;
  overflow: hidden;
}

.gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at center,
    #6ed7ca,
    rgba(255, 255, 255, 0)
  );
  animation: moveBlob 20s infinite;
  border-radius: 50%;
  filter: blur(100px);
}

@keyframes moveBlob {
  0% {
    transform: translate(-70%, -70%) scale(1);
  }
  25% {
    transform: translate(70%, -70%) scale(2);
  }
  50% {
    transform: translate(-70%, 70%) scale(1);
  }
  75% {
    transform: translate(70%, 70%) scale(2);
  }
  100% {
    transform: translate(-70%, -70%) scale(1);
  }
}

/* This is just to transition when you change the viewport size. */
* {
  transition: all 0.5s ease-out;
  font-family: "Manrope", serif !important;
  font-optical-sizing: auto;
  font-style: normal;
}

.heading,
.text {
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: white;
  border: none;
}

.text {
  font-size: 1.2rem;
  padding-bottom: 2rem;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  z-index: 1;
  color: white;
  width: 100%;
  background-color: transparent;
}

.form {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto;
  gap: 1rem;
  width: 50%;
  /* From https://css.glass */
  background: rgba(255, 255, 255, 0.22);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 2rem;
}

.images {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.images img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
}

.images p {
  font-size: 30px;
}

.label {
  display: grid;
  gap: 0.5rem;
  width: 100%;
  text-align: left;
  font-size: 1rem;
  background-color: transparent;
}

.lbl {
  font-size: 1rem;
  width: 100%;
  background-color: transparent;
  color: white;
}

.input {
  padding: 1rem 1.5rem !important;
  border-radius: 8px;
  border: none;
  width: 100%;
}

.button {
  padding: 14px 24px;
  border-radius: 8px;
  background-color: #00dfdf;
  color: black;
  font-weight: 800;
  width: 100%;
  border: none;
  font-size: 1rem;
  margin: 0;
}
.button:hover {
  background-color: white;
  cursor: pointer;
}

.list {
  list-style: none;
  padding: 0;
  padding-top: 3rem;
  margin: 0;
  display: flex;
  gap: 2rem;
}

.list > li {
  max-width: 20rem;
  text-align: left;
}

.sec {
  background-color: transparent;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
}
.dlabel {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  background-color: transparent;

  input {
    border-radius: 50%;
    overflow: hidden;
  }
}

@media screen and (max-width: 426px) {
  .form {
    width: 70%;
  }
}
</style>
